export const MAPBOX_SATELLITE = {
    "title": "MAPBOX",
    "collection_id": "MAPBOX",
    "min_date": "2013-01-01",
    "max_date": "2025-01-01",
    "extent": {
        "type": "Polygon",
        "crs": {
            "type": "name",
            "properties": {
                "name": "urn:ogc:def:crs:EPSG::4326"
            }
        },
        "coordinates": [
            [
                [
                    -171.791110603,
                    18.91619
                ],
                [
                    -171.791110603,
                    71.3577635769
                ],
                [
                    -66.96466,
                    71.3577635769
                ],
                [
                    -66.96466,
                    18.91619
                ],
                [
                    -171.791110603,
                    18.91619
                ]
            ]
        ]
    },
    "stac_address": null,
    "capabilities": null,
    "citation": "",
    "min_zoom_level": 15,
    "max_zoom_level": 13,
    "stac_query_prefix": null,
    "date_display_resolution": null,
    "expr": null,
    "jq": null,
    "color_map": null,
    "color_ramp": null,
    "global_min": null,
    "global_max": null,
    "tile_server": null,
    "tile_urls":[`https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}@1x.jpg90?access_token=${process.env.REACT_APP_MAPBOX_TOKEN}`],
    "__typename": "syncarto_app_data_source"
}